export default "__VITE_ASSET__DSLASNvT__"